// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from 'brastrap/containers/link/LinkContainer';
import type { InfoWindowProps as Props } from './map.types';

const InfoWindowContent = (props: Props) => {
  const aProps = {
    className: 'c-info-window-content__label u-block-link',
    href: props.url,
  };
  return (
    <div>
      <Link {...aProps}>
        <span className="c-info-window-content__text">{props.label}</span>
      </Link>
      <b>
        <FormattedMessage
          id="google-map.info-window.address"
          defaultMessage="Address"
        />
      </b>
      <p>
        {props.address.map((text, index) => (
          <span key={index}>
            {text}
            <br />
          </span>
        ))}
      </p>
    </div>
  );
};

InfoWindowContent.defaultProps = {
  address: [],
};

export default InfoWindowContent;
